import { globalData } from "@/data";
import { axios, getCookie } from "@/utils";

export const getDataHandler = async (
    apiUrl,
    id,
    query,
    isFileRequest,
    fileFilter,
    responseType = globalData.responseTypes.json,
) => {
    let fullApiUrl = "";

    if (query && id) fullApiUrl = `${apiUrl}/${id}${query}`;
    else if (id) fullApiUrl = `${apiUrl}/${id}`;
    else if (query) fullApiUrl = `${apiUrl}${query}`;
    else fullApiUrl = apiUrl;

    if (isFileRequest) fullApiUrl += `/export/${fileFilter}/v2`;

    return axios.get(
        fullApiUrl,
        {
            headers: {
                Authorization: `Bearer ${getCookie("token")}`, // eslint-disable-line
                "Content-Type": "application/json",
            },
            responseType,
        },
    );
};

export const postDataHandler = async (
    apiUrl,
    id,
    data,
    isFormData,
    isPublicService,
    subApi,
    query,
) => {
    let fullApiUrl = id ? `${apiUrl}/${id}` : apiUrl;

    if (subApi) fullApiUrl += `/${subApi}`;

    if (query) fullApiUrl += `${query}`;

    return axios.post(
        fullApiUrl,
        data,
        {
            headers: {
                ...!isPublicService && { Authorization: `Bearer ${getCookie("token")}` }, // eslint-disable-line
                "Content-Type": isFormData ? "multipart/form-data" : data instanceof URLSearchParams ? "application/x-www-form-urlencoded" : "application/json",
            },
        },
    );
};

export const updateDataHandler = async (
    apiUrl,
    id,
    data,
    isFormData,
    query,
    subApi,
    isSetPasswordRequest,
    token,
) => {
    let fullApiUrl = "";

    if (id) fullApiUrl = `${apiUrl}/${id}`;
    else if (query) fullApiUrl = `${apiUrl}${query}`;
    else fullApiUrl = apiUrl;

    if (subApi) fullApiUrl += `/${subApi}`;

    return axios.put(
        fullApiUrl,
        data,
        {
            headers: {
                Authorization: `Bearer ${isSetPasswordRequest ? token : getCookie("token")}`, // eslint-disable-line
                "Content-Type": isFormData ? "multipart/form-data" : "application/json",
            },
        },
    );
};

export const deleteDataHandler = async (
    apiUrl,
    id,
    data,
) => axios[globalData.httpMethods.httpDelete](
    id ? `${apiUrl}/${id}` : apiUrl,
    {
        data,
        headers: { Authorization: `Bearer ${getCookie("token")}` }, // eslint-disable-line
    },
);
